import { createContext, useContext } from "react";

export const SetupWizardContext = createContext({
  wizardActive: false,
  wizardPhase: "idle",
  currentStepKey: null,
  initialPendingKeys: [],
  pendingStepKeys: [],
  stepsStatus: { mailbox: false, signature: false, icp: false, kb: false },
  skippedSteps: [],
  minimized: false,
  launchSource: null,
  verifying: false,
  verifyError: null,
  kbDetectionState: "detecting",
  icpDetectionState: "detecting",
  mailboxDetectionState: "detecting",
  signatureDetectionState: "detecting",
  startWizardFromWelcome: async () => {},
  startWizardFromLearningCenter: () => {},
  dismissWizard: () => {},
  minimizeWizard: () => {},
  maximizeWizard: () => {},
  confirmStepDone: async () => {},
  skipCurrentStep: () => {},
  skipAllSetup: () => {},
  skipSetupFromIntro: () => {},
  proceedFromIntro: () => {},
  proceedFromOutro: async () => {},
});

export const useSetupWizard = () => useContext(SetupWizardContext);
